/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataGetAdminUserPointsDetailPageListRespVo } from './PageDataGetAdminUserPointsDetailPageListRespVo';
import {
    PageDataGetAdminUserPointsDetailPageListRespVoFromJSON,
    PageDataGetAdminUserPointsDetailPageListRespVoFromJSONTyped,
    PageDataGetAdminUserPointsDetailPageListRespVoToJSON,
    PageDataGetAdminUserPointsDetailPageListRespVoToJSONTyped,
} from './PageDataGetAdminUserPointsDetailPageListRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataGetAdminUserPointsDetailPageListRespVo
 */
export interface ResponsePageDataGetAdminUserPointsDetailPageListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataGetAdminUserPointsDetailPageListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataGetAdminUserPointsDetailPageListRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataGetAdminUserPointsDetailPageListRespVo}
     * @memberof ResponsePageDataGetAdminUserPointsDetailPageListRespVo
     */
    data?: PageDataGetAdminUserPointsDetailPageListRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataGetAdminUserPointsDetailPageListRespVo interface.
 */
export function instanceOfResponsePageDataGetAdminUserPointsDetailPageListRespVo(value: object): value is ResponsePageDataGetAdminUserPointsDetailPageListRespVo {
    return true;
}

export function ResponsePageDataGetAdminUserPointsDetailPageListRespVoFromJSON(json: any): ResponsePageDataGetAdminUserPointsDetailPageListRespVo {
    return ResponsePageDataGetAdminUserPointsDetailPageListRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataGetAdminUserPointsDetailPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataGetAdminUserPointsDetailPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataGetAdminUserPointsDetailPageListRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataGetAdminUserPointsDetailPageListRespVoToJSON(json: any): ResponsePageDataGetAdminUserPointsDetailPageListRespVo {
    return ResponsePageDataGetAdminUserPointsDetailPageListRespVoToJSONTyped(json, false);
}

export function ResponsePageDataGetAdminUserPointsDetailPageListRespVoToJSONTyped(value?: ResponsePageDataGetAdminUserPointsDetailPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataGetAdminUserPointsDetailPageListRespVoToJSON(value['data']),
    };
}

